import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorPageComponent } from '../app/errorpage/errorpage.component';
import { LoginComponent } from './components/login.component';
import { AuthGuard } from './guards/auth.guard';
import { LogoutGuard } from './guards/logout.guard';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'overview', loadChildren: './dashboard/dashboard.module#DashboardModule', canActivate: [AuthGuard] },
  { path: 'vehicles', loadChildren: './vehicles/vehicles.module#VehiclesModule', canActivate: [AuthGuard] },
  { path: 'trips', loadChildren: './trips/trips.module#TripsModule', canActivate: [AuthGuard] },
  { path: 'maintenance', loadChildren: './maintenance/maintenance.module#MaintenanceModule', canActivate: [AuthGuard] },
  { path: 'analytics', loadChildren: './analytics/analytics.module#AnalyticsModule', canActivate: [AuthGuard] },
  { path: '404error', component: ErrorPageComponent},
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'logout', component: LoginComponent, canActivate: [LogoutGuard] },
  { path: '**', redirectTo: '404error' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }